import {MakeDialog} from "../../../components/Shared/MakeDialog";
import React, {Component, Fragment} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {
  formsCheckboxUpdater,
  formsDataUpdater,
  formsUpdater,
  getFormFieldValue
} from "../../Applications/shared/shared";
import {getData, postData} from "../../../api/doLogin";
import {getGlobalState} from "../../../constants/GlobalStore";

export class TransferCalendarDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenCalendar: props.currentCalendar || "",
      copy: 0,
      calendarList: [],
      loaded: false
    }
    this.loginId = getGlobalState("loginID");
  }

  componentDidMount() {
    this.loadCalendarMenu();
  }

  loadCalendarMenu() {
    getData("calendar/list", {})
      .then((data) => {
        this.setState({calendarList: data.data.calendarList, loaded: true});
      })
      .catch((err) => {
        console.error(err);
      });
  }

  saveToCalendar() {
    postData(`calendar/transfer/${this.props.eventId}/${this.state.chosenCalendar}`, {copy: this.state.copy})
      .then((data) => {
        if (data.status === "Success") {
          this.props.onSave && this.props.onSave(this.state.chosenCalendar, data.data.new || null);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  render() {

    return (
      <MakeDialog isOpen={this.state.loaded}
                  className={"TransferCalendarDialog"}
                  footer={<div>
                    <Button color={"primary"}
                            disabled={String(this.props.currentCalendar) === String(this.state.chosenCalendar)}
                            onClick={() => this.saveToCalendar()}>Save</Button>
                    <Button onClick={() => this.props.onClose && this.props.onClose()}>Close</Button>
                  </div>}
                  header="Calendar Transfer">
        <Row>
          <Col xs={12} lg={6}>
            <FormGroup>
              <Label for="chosenCalendar">Select Calendar</Label>
              <Input type="select" id="chosenCalendar" placeholder=""
                     value={getFormFieldValue(this.state.chosenCalendar)}
                     onChange={(evt) => this.setState({chosenCalendar: evt.target.value})}>
                >
                <option key={0} value={this.loginId}
                        disabled={String(this.props.currentCalendar) === String(this.loginId)}>My Calendar</option>
                {(this.state.calendarList || []).map((val, i) => {
                  if (val.cal_id === this.loginId) return;
                  return <option key={i + 1} value={val.cal_id}
                                 disabled={String(this.props.currentCalendar) === String(val.cal_id)}>{`${val.agencyDisplay} > ${val.userDisplay}`}</option>
                })}
              </Input>
            </FormGroup>
          </Col>
          <Col sm={12}>
            <FormGroup check className="form-check-inline form-group-condensed"
                       style={{}}>
              <Label check htmlFor="copy">
                <Input type="checkbox" id="copy"
                       value="copy"
                       checked={getFormFieldValue(this.state.copy) === 1}
                       onChange={(evt) => this.setState({copy: evt.target.checked ? 1 : 0})}/>
                Copy Appointment (make sure entry is saved first)
              </Label>
            </FormGroup>
          </Col>
        </Row>
      </MakeDialog>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/modals/TransferCalendarDialog.js